<template>
	<div class="container">
		<div class="top_title" style="display: flex;flex-direction: row;justify-content: space-between;">
			<router-link class="icon_back" :to="{name:'H010010'}" tag="span"></router-link>
			<div style="position: absolute;left: 50%;transform: translate(-50%,0);">业绩排名</div>
			<div>
				<select class="weui-select" style="color:#54C3f1;" v-model="currentType" >
					<option value='1'>英语</option>
					<option value='2'>Steam</option>
				</select>
			</div>
		</div>
		<div style="background-color: #eee;position: fixed;top: 2.4rem;width: 100%;">
			<div class="weui-flex top_tabs">
				<div class="weui-flex__item"><span :class="{active: I_FLAG1 == 1}"
						@click="changeTab('I_FLAG1',1)">本月排名</span></div>
				<div class="weui-flex__item"><span :class="{active: I_FLAG1 == 2}"
						@click="changeTab('I_FLAG1',2)">上月排名</span></div>
				<div class="weui-flex__item"><span :class="{active: I_FLAG1 == 3}"
						@click="changeTab('I_FLAG1',3)">年度排名</span></div>
			</div>

			<div class="labels">
				<span :class="{active: I_FLAG2 == 1}" @click="changeTab('I_FLAG2',1)">按金额</span>
				<span :class="{active: I_FLAG2 == 2}" @click="changeTab('I_FLAG2',2)">按人数</span>
			</div>
		</div>

		<div class="items">
			<div class="item" v-for="i in dataList">
				<p class="no">{{i.I_NO}}</p>
				<p class="name">{{i.I_NAME}}</p>
				<p class="amt">{{i.I_AMT}}<span class="special">元</span></p>
				<p class="num">{{i.I_NUM}}<span class="special">人</span></p>
			</div>
		</div>
		<!--<table class="items">-->
		<!--<tr class="item" v-for="i in dataList">-->
		<!--<td class="no">{{i.I_NO}}</td>-->
		<!--<td class="name">{{i.I_NAME}}</td>-->
		<!--<td class="amt">{{i.I_AMT}}<span class="special">元</span></td>-->
		<!--<td class="num">{{i.I_NUM}}<span class="special">人</span></td>-->
		<!--</tr>-->
		<!--</table>-->
	</div>
</template>

<script>
	import DataRequestFactory from '@/factories/dataRequestFactory.js'
	export default {
		name: "H500010",
		data() {
			return {
				I_FLAG1: 1,
				I_FLAG2: 1,
				dataList: [],
				currentType: 1
			}
		},
		created() {
			this.search()
		},
		watch: {
			currentType(newValue, oldValue) {
				this.search()
			}
		},
		methods: {
			changeTab(key, value) {
				this[key] = value
				this.search()
			},
			search() {
				let param = {
					I_FLAG1: this.I_FLAG1,
					I_FLAG2: this.I_FLAG2,
					I_TYPE: this.currentType
				}
				DataRequestFactory.I500010(param).then((response) => {
					console.log(response)
					if (response.resultCode == '0') {
						this.dataList = response.dataList
					}
				})
			}
		}
	}
</script>

<style scoped>
	@import '../assets/css/pages/H500010.css';
	@import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H500010.vue